import { FC } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { Alert, Card, CardContent, CardHeader, TextField } from '@mui/material';
// import { Link } from 'react-router-dom';
// import Routes from '@/router/Routes.ts';
import * as z from 'zod';
import LoaderOverlay from '@/components/ui/LoaderOverlay/LoaderOverlay.tsx';
import { useAuthContext } from '@/context/AuthContext.tsx';
import LoadingButton from '@/components/ui/LoadingButton/LoadingButton.tsx';

const loginSchema = z.object({
  email: z.string().min(1, { message: 'This field is required.' }).email('Invalid email'),
  password: z.string().min(1, { message: 'This field is required.' }),
});

type LoginSchema = z.infer<typeof loginSchema>;

const LoginPage: FC = () => {
  const { control, handleSubmit } = useForm<LoginSchema>({
    resolver: zodResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  });
  const { t } = useTranslation();
  const {
    loginQuery: { mutateAsync: login, isPending: isLoadingLogin, error: errorLogin, isError: isErrorLogin },
  } = useAuthContext();
  const handleLogin = (data: LoginSchema) => {
    void (async () => {
      try {
        if (isLoadingLogin) return;

        await login({
          email: data.email,
          password: data.password,
        });
      } catch (error) {
        console.error(error);
      }
    })();
  };

  return (
    <div className="flex grow justify-center items-center px-8 max-w-full">
      <form onSubmit={handleSubmit(handleLogin)} className="max-w-full">
        <LoaderOverlay isLoading={false}>
          <Card elevation={10} className="rounded-xl w-[552px] max-w-full">
            <CardHeader
              title="Sign in"
              // subheader={
              //   isRegisterEnabled ? (
              //     <span>
              //       If you don’t have an account You can{' '}
              //       <Link className="font-medium text-text-link no-underline" to={Routes.REGISTER}>
              //         Register here
              //       </Link>
              //     </span>
              //   ) : null
              // }
            />
            <CardContent>
              <div className="flex flex-col gap-4">
                {isErrorLogin && <Alert severity="error">{errorLogin?.message}</Alert>}
                <Controller
                  control={control}
                  name="email"
                  render={({ field: { onChange, value }, formState: { errors } }) => (
                    <TextField
                      error={!!errors.email}
                      helperText={errors.email?.message}
                      value={value}
                      onChange={onChange}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      variant="outlined"
                      label={t('label.email')}
                      placeholder={t('placeholder.email')}
                    />
                  )}
                />
                <Controller
                  control={control}
                  name="password"
                  render={({ field: { onChange, value }, formState: { errors } }) => (
                    <TextField
                      error={!!errors.password}
                      helperText={errors.password?.message}
                      value={value}
                      onChange={onChange}
                      type={'password'}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      variant="outlined"
                      label={t('label.password')}
                      placeholder={t('placeholder.password')}
                    />
                  )}
                />
                <LoadingButton loading={isLoadingLogin} type="submit" variant="contained" color="primary" size="large">
                  {t('button.login')}
                </LoadingButton>
              </div>
            </CardContent>
            {/*<CardActions>*/}
            {/*  <div className="p-2">*/}
            {/*    <Link className="text-secondary-400" to={Routes.FORGOT_PASSWORD}>*/}
            {/*      Forgot password?*/}
            {/*    </Link>*/}
            {/*  </div>*/}
            {/*</CardActions>*/}
          </Card>
        </LoaderOverlay>
      </form>
    </div>
  );
};

export default LoginPage;
